

export const PRIMHeaderRouteBlacklist = [ 
    '/onboarding',
    '/contribute-config',
    '/my-edit',
    '/edit/',
    '/moderate/',
    '/datasets+/moderate', // for the self managed route /datasets/:contentType/:contentId/:edit_moderate
    '/datasets+/edit', // for the self managed route /datasets/:contentType/:contentId/:edit_moderate
    '/choose-template',
    '/userAgreement',
    '/tci',
    '/platformBuilder',
    '/self-serve-survey',
    '/reset-password',
    // '/global-search'
  ];
  export const SECHeaderRouteWhitelist = [ 
    '/grouped-published-listing',
    '/published-listing',
    // '/onboarding',
    // '/my-edit'
  ];
  export const footerRouteBlacklist = [ 
    '/edit',
    '/moderate',
    '/contribute-config',
    '/search',
    '/profile/userProfiles',
    '/my-dashboard',
    '/onboarding',
    '/my-edit',
    '/choose-template',
    '/userAgreement',
    '/tci',
    '/synthesisV2',
    '/playground',
    '/platformBuilder',
    '/insightMatrix',

    '/annoBase',
    '/aiChat',
    '/annotation-explorer',
    '/self-serve-survey',
    '/reports',
    '/overview-dashboard',
    '/published-listing',
    '/published-page'

   ]